import { logWrapper } from '../utils';
import jQuery from 'jquery';

function draggableDirectiveFactory(runtimeConstant) {
  function link(scope, element) {
    const el = element[0];
    el.draggable = true;

    el.addEventListener('dragstart', (e) => {
      const fn = scope.draggable();
      const draggable = fn();

      if (!draggable) {
        e.preventDefault();
        return true;
      }

      jQuery('body').addClass('dragdoc');

      const header = el.parentElement.parentElement.children[0].cloneNode(true);
      const elements = el.parentElement.children;
      const activeElements = [];

      for (let i = 0; i < el.parentElement.childElementCount; i++) {
        const tr = elements[i];
        if (tr.className.includes('active')) {
          activeElements.push(tr.cloneNode(true));
        }
      }

      const ids = activeElements.map(t => t.getAttribute('rowid'));

      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('Text', 'docs:' + ids.join(';'));
      el.classList.add('drag');

      const table = document.createElement('table');
      Object.assign(table.style, {
        position: 'absolute',
        display: 'absolute',
        background: 'white',
        border: '1px solid #c6c6c6',
        width: 'auto',
        zIndex: 1000,
        left: '-250px',
        top: '-250px'
      });

      table.className = 'table table-striped table-header-responsive';
      table.id = 'drag-element';
      document.body.appendChild(table);

      const htr = header.children[0];
      htr.removeChild(htr.children[3]);
      htr.removeChild(htr.children[5]);
      htr.removeChild(htr.children[5]);

      const size = activeElements.length;
      const row = document.createElement('tr');
      row.className = 'line shadow';

      const iconTd = document.createElement('td');
      iconTd.className = 'icon';
      iconTd.style = 'padding: 10px; text-overflow: clip;';
      iconTd.width = '50px';

      const label = document.createElement('label');
      label.className = 'number-circle';
      label.appendChild(document.createTextNode(size));
      iconTd.appendChild(label);

      const textTd = document.createElement('td');
      textTd.appendChild(document.createTextNode('Documentos Selecionados'));
      textTd.style = 'padding-right:10px;';

      row.appendChild(iconTd);
      row.appendChild(textTd);
      table.appendChild(row);

      e.dataTransfer.setDragImage(table, 5, 5);
      return false;
    });

    el.addEventListener('dragend', () => {
      jQuery('body').removeClass('dragdoc');
      el.ondrag = null;

      const dragElement = document.getElementById('drag-element');
      if (dragElement) {
        dragElement.remove();
      }

      el.classList.remove('drag');
      return false;
    });
  }

  function run() {
    return {
      restrict: 'A',
      scope: {
        draggable: '&',
      },
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const draggableDirective = ['runtimeConstant', draggableDirectiveFactory];
